/* Promo countdown bar — sections/promo-bar.liquid. Scheduling, timer types, URL/UTM
   targeting and the close button live here so the Liquid stays cacheable. Dates arrive as
   "YYYY-MM-DD HH:MM"; data-offset is the store's UTC offset (e.g. -0700) or empty for the
   visitor's local time. */
(function () {
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var utils = {
    offsetMinutes: function (o) { if (!o) return null; var sign = o[0] === '-' ? -1 : 1; return sign * (parseInt(o.slice(1, 3), 10) * 60 + parseInt(o.slice(3, 5), 10)); },
    daysInMonth: function (y, m) { return new Date(Date.UTC(y, m, 0)).getUTCDate(); },
    fromParts: function (y, m, d, h, mi, offset) {
      d = Math.min(d, utils.daysInMonth(y, m));
      if (offset == null || offset === '') return new Date(y, m - 1, d, h, mi, 0).getTime();
      return Date.UTC(y, m - 1, d, h, mi, 0) - utils.offsetMinutes(offset) * 60000;
    },
    parseShopDate: function (s, offset) {
      if (!s) return null;
      var m = String(s).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})/);
      if (!m) return null;
      var t = utils.fromParts(+m[1], +m[2], +m[3], +m[4], +m[5], offset);
      return isNaN(t) ? null : t;
    },
    shopParts: function (now, offset) {
      if (offset == null || offset === '') { var l = new Date(now); return { y: l.getFullYear(), m: l.getMonth() + 1, d: l.getDate(), wd: l.getDay() }; }
      var t = new Date(now + utils.offsetMinutes(offset) * 60000); return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate(), wd: t.getUTCDay() };
    },
    nextDailyReset: function (now, hour, offset) { var p = utils.shopParts(now, offset); var t = utils.fromParts(p.y, p.m, p.d, hour, 0, offset); return t > now ? t : t + 86400000; },
    nextWeeklyReset: function (now, weekday, hour, offset) { var p = utils.shopParts(now, offset); var delta = (weekday - p.wd + 7) % 7; var t = utils.fromParts(p.y, p.m, p.d, hour, 0, offset) + delta * 86400000; return t > now ? t : t + 7 * 86400000; },
    split: function (ms, daysAsHours) {
      var s = Math.max(0, Math.floor(ms / 1000)), days = Math.floor(s / 86400), hours = Math.floor(s % 86400 / 3600);
      if (daysAsHours) { hours += days * 24; days = 0; }
      return { days: days, hours: hours, minutes: Math.floor(s % 3600 / 60), seconds: s % 60 };
    },
    pathMatches: function (path, list) {
      return list.split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean).some(function (p) { return p === '/' ? path === '/' : (path === p || path.indexOf(p.replace(/\/$/, '') + '/') === 0 || path === p.replace(/\/$/, '')); });
    },
    sourceMatches: function (sources, search, referrer) {
      var want = sources.split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); if (!want.length) return true;
      var utm = (search.match(/[?&]utm_source=([^&]+)/) || [])[1]; utm = utm ? decodeURIComponent(utm).toLowerCase() : '';
      var host = ''; try { host = referrer ? new URL(referrer).hostname.toLowerCase() : ''; } catch (e) {}
      return want.some(function (w) { return utm === w || (host && host.indexOf(w) !== -1); });
    }
  };
  if (typeof globalThis !== 'undefined') globalThis.PromoBarUtils = utils;
  if (typeof HTMLElement === 'undefined') return;

  class PromoBar extends HTMLElement {
    connectedCallback() { this.init(); }
    disconnectedCallback() { this.stop(); }
    stop() { clearInterval(this.tickTimer); clearTimeout(this.wakeTimer); }
    init() {
      this.stop();
      var d = this.dataset, self = this; this.design = d.designMode === 'true';
      this.units = {};
      ['days', 'hours', 'minutes', 'seconds'].forEach(function (u) { var el = self.querySelector('[data-unit="' + u + '"]'); self.units[u] = { el: el, digit: el && el.querySelector('.promo-bar__digit') }; });
      this.colons = {}; ['days', 'hours', 'minutes'].forEach(function (u) { self.colons[u] = self.querySelector('[data-colon="' + u + '"]'); });
      this.timerEl = this.querySelector('.promo-bar__timer'); this.endedEl = this.querySelector('.promo-bar__ended'); this.headingEl = this.querySelector('.promo-bar__heading');
      if (this.headingEl) this.headingEl.textContent = this.headingEl.dataset.original || this.headingEl.textContent;
      if (!this.design) {
        var path = location.pathname;
        if (d.includeUrls && !utils.pathMatches(path, d.includeUrls)) { this.hidden = true; return; }
        if (d.excludeUrls && utils.pathMatches(path, d.excludeUrls)) { this.hidden = true; return; }
        if (d.utmSources) {
          var skey = 'promo-bar-source-' + this.id, ok = false;
          try { ok = sessionStorage.getItem(skey) === '1'; } catch (e) {}
          if (!ok && utils.sourceMatches(d.utmSources, location.search, document.referrer)) { ok = true; try { sessionStorage.setItem(skey, '1'); } catch (e) {} }
          if (!ok) { this.hidden = true; return; }
        }
        var dkey = 'promo-bar-dismissed-' + this.id;
        if (d.dismissible === 'true') {
          try { if (sessionStorage.getItem(dkey) === '1') { this.hidden = true; return; } } catch (e) {}
          var close = this.querySelector('.promo-bar__close');
          if (close && !close.dataset.bound) { close.dataset.bound = '1'; close.addEventListener('click', function () { try { sessionStorage.setItem(dkey, '1'); } catch (e) {} self.hidden = true; }); }
        }
        var now = Date.now(), start = utils.parseShopDate(d.start, d.offset);
        if (start && now < start) { this.hidden = true; this.wakeTimer = setTimeout(function () { self.init(); }, Math.min(start - now, 3600000)); return; }
      }
      this.hidden = false;
      this.end = this.computeEnd();
      this.tick(); this.tickTimer = setInterval(function () { self.tick(); }, 1000);
    }
    computeEnd() {
      var d = this.dataset, now = Date.now();
      if (d.mode === 'daily') return utils.nextDailyReset(now, parseInt(d.dailyHour || '0', 10), d.offset);
      if (d.mode === 'weekly') return utils.nextWeeklyReset(now, parseInt(d.weeklyDay || '0', 10), parseInt(d.dailyHour || '0', 10), d.offset);
      if (d.mode === 'evergreen') {
        var mins = parseInt(d.evergreenMinutes || '15', 10), key = 'promo-bar-end-' + this.id, end = 0;
        try { end = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
        if (!end || end < now) { end = now + mins * 60000; try { localStorage.setItem(key, String(end)); } catch (e) {} }
        return end;
      }
      return utils.parseShopDate(d.end, d.offset);
    }
    tick() {
      var d = this.dataset;
      if (!this.end) { if (this.timerEl) this.timerEl.hidden = true; return; }
      var rem = this.end - Date.now();
      if (rem <= 0) {
        if (d.mode === 'daily' || d.mode === 'weekly' || d.mode === 'evergreen') { this.end = this.computeEnd(); rem = this.end - Date.now(); }
        else { return this.onEnded(); }
      }
      var p = utils.split(rem, d.daysAsHours === 'true');
      var hideDays = d.daysAsHours === 'true' || (d.hideZeroDays === 'true' && p.days === 0), hideSec = d.hideSeconds === 'true';
      if (this.units.days.el) this.units.days.el.hidden = hideDays; if (this.colons.days) this.colons.days.hidden = hideDays;
      if (this.units.seconds.el) this.units.seconds.el.hidden = hideSec; if (this.colons.minutes) this.colons.minutes.hidden = hideSec;
      if (this.units.days.digit) this.units.days.digit.textContent = String(p.days);
      if (this.units.hours.digit) this.units.hours.digit.textContent = pad(p.hours);
      if (this.units.minutes.digit) this.units.minutes.digit.textContent = pad(p.minutes);
      if (this.units.seconds.digit) this.units.seconds.digit.textContent = pad(p.seconds);
      var um = parseInt(d.urgencyMinutes || '0', 10);
      if (this.headingEl && um > 0 && d.urgencyText && rem < um * 60000 && this.headingEl.textContent !== d.urgencyText) this.headingEl.textContent = d.urgencyText;
    }
    onEnded() {
      this.stop();
      if (this.dataset.endedAction === 'hide' && !this.design) { this.hidden = true; return; }
      if (this.timerEl) this.timerEl.hidden = true; if (this.endedEl) this.endedEl.hidden = false;
    }
  }
  if (!customElements.get('promo-bar')) customElements.define('promo-bar', PromoBar);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('promo-bar').forEach(function (el) { el.init(); }); });
})();
